import { render, staticRenderFns } from "./FooterElemInPC.vue?vue&type=template&id=44781e8c&scoped=true"
import script from "./FooterElemInPC.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterElemInPC.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FooterElemInPC.vue?vue&type=style&index=0&id=44781e8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44781e8c",
  null
  
)

export default component.exports